const TESTIMONIAL = {
  SET_TESTIMONIAL_QUERY: 'SET_TESTIMONIAL_QUERY',
};

export default TESTIMONIAL;
